import {DOM} from '../core/dom';
import {FreelancerSignup} from '../core/freelancer-signup';

export namespace FreelancerCallToAction {
  export function onload(): void {
    DOM.onIdClick('freelancer-call-to-action-btn', FreelancerSignup.display);
  }
}